import Vue from 'vue'
import Router from 'vue-router'
import tenantsPage from '../../ugsrc/components/tenants/tenants.vue'
import appsPage from '../../ugsrc/components/apps/apps.vue'
import docsPage from '../../ugsrc/components/docs/docs.vue'
import noAppNoDoc from '../../ugsrc/components/subcomponents/noAppNoDoc.vue';
Vue.use(Router)

const commonRoutes = [
    {
        path: '/tenants',
        name: tenantsPage,
        component: tenantsPage
    },
    {
        path: '/apps',
        name: appsPage,
        component: appsPage
    },
    {
        path: '/docs/:appname',
        name: docsPage,
        component: docsPage
    },
    {
        path: '/noapp_nodoc',
        name: noAppNoDoc,
        component: noAppNoDoc,
        beforeEnter: (to, from, next) => {
            if(from.path == '/'){
                next();
            } else{
                next({ path: from.path });
            }
        }
    }
]
  
export default commonRoutes